// extracted by mini-css-extract-plugin
export var checkbox = "_9l-0";
export var circle = "_9l-3";
export var horizontalContainer = "_9l-7";
export var sm = "_9l-5";
export var switch0 = "_9l-2";
export var switchDisabled = "_9l-8";
export var switchEnabled = "_9l-1";
export var textSwitchContainer = "_9l-9";
export var textSwitchOption = "_9l-a";
export var textSwitchOptionSelected = "_9l-b";
export var verticalContainer = "_9l-6";
export var xs = "_9l-4";